export enum EFeatureFlag {
    FEATURE_FLAG_ROUTE = 'feature_flag_route',
    SENTRY_SESSION_REPLAY = 'sentry_session_replay',
    INBOX_GROUP_BY_PROPERTY = 'inbox_group_by_property',
    TRIAGE_INBOX_PAGE = 'triage_inbox_page',
    DOWNLOAD_CSV_FROM_ANALYTICS = 'download_csv_from_analytics',
};
